// extracted by mini-css-extract-plugin
module.exports = {"compareProductsContainer":"styles_compareProductsContainer__Z3QGv","toggledContainer":"styles_toggledContainer__1UGuo","noStyleButton":"styles_noStyleButton__3hoQQ"};